import { render, staticRenderFns } from "./Appendix.vue?vue&type=template&id=1a77c82c&scoped=true&"
import script from "./Appendix.vue?vue&type=script&lang=js&"
export * from "./Appendix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77c82c",
  null
  
)

export default component.exports